<template>
  <el-dialog
    :visible.sync="state"
    :append-to-body="true"
    custom-class="prev-dialog__dialog">
    {{ message }}
    <div class="prev-dialog__dialog-action">
      <button class="prev-dialog__button prev-dialog__button--primary" @click="dataReset()">前のページへ戻る</button>
      <button class="prev-dialog__button prev-dialog__button--cancel" @click="cancel()">キャンセル</button>
    </div>
  </el-dialog>
</template>



<script>
import {
  Dialog,
} from 'element-ui'
import 'element-ui/lib/theme-chalk/dialog.css'
import { mapState } from 'vuex'

export default {
  components: {
    'el-dialog': Dialog,
  },
  computed: {
    ...mapState({
      pageLoading: state => state.page.loading,
    })
  },
  props: {
    value: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: true,
    },
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    dataReset() {
      let root = this.$route.path.match(/gogatsu/) ?  this.config.path.root_gogatsu : this.config.path.root;

      this.$router.push({
        path: root + '/step/sizes/1',
        query: '',
      })

      this.state = false
    },
    cancel() {
      this.state = false
      this.$store.commit('page/loading', false)
    },
  }
}
</script>



<style lang="scss">
.prev-dialog {
  &__dialog {
    border-radius: 8px;
    text-align: center;
    width: 90%;
    @include breakpoints-min(sm) {
      width: 80%;
    }
    @include breakpoints-min(md) {
      width: 65%;
    }
    @include breakpoints-min(lg) {
      width: 512px;
    }
  }
  &__dialog-action {
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  &__button {
    $e: &;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    display: inline-block;
    appearance: none;
    transition: $transition;
    outline: none;
    border: none;
    background: transparent;
    font-size: 12px;
    text-align: center;
    color: $oc-gray-8;
    &:disabled {
      cursor: no-drop;
    }
    &--primary,
    &--cancel {
      border-radius: 999px;
      width: 176px;
      padding-top: 16px;
      padding-bottom: 16px;
    }
    &--primary {
      border: 1px solid $oc-gray-4;
      @include hover() {
        border-color: $accent-color;
        color: $accent-color;
      }
      @include active() {
        border-color: $accent-color;
        background-color: $accent-color-bg;
        color: $accent-color;
      }
    }
    &--cancel {
      border: 1px solid $accent-color;
      background-color: $accent-color;
      color: #fff;
      margin-left: 16px;
      @include hover() {
        border-color: $accent-color-hover;
        background-color: $accent-color-hover;
      }
      @include active() {
        border-color: $accent-color-active;
        background-color: $accent-color-active;
        color: #fff;
      }
    }
  }
}

.app-gogatsu ~ .el-dialog__wrapper {
    .prev-dialog {

        &__button {
            $e: &;
            &--primary {
                border: 1px solid $oc-gray-4;
                @include hover() {
                    border-color: $gogatsu-accent-color;
                    color: $gogatsu-accent-color;
                }
                @include active() {
                    border-color: $gogatsu-accent-color;
                    background-color: $gogatsu-accent-color-bg;
                    color: $gogatsu-accent-color;
                }
            }
            &--cancel {
                border: 1px solid $gogatsu-accent-color;
                background-color: $gogatsu-accent-color;
                color: #fff;
                margin-left: 16px;
                @include hover() {
                    border-color: $gogatsu-accent-color-hover;
                    background-color: $gogatsu-accent-color-hover;
                }
                @include active() {
                    border-color: $gogatsu-accent-color-active;
                    background-color: $gogatsu-accent-color-active;
                    color: #fff;
                }
            }
        }
    }
}
</style>
